import React from "react";

import "./ComponentTitle.less";

const ComponentTitle = ({ name }) => {
  return <div className={"component-title-container"}>{name}</div>;
};

export default ComponentTitle;
